const navigation = {
    'navigate-home': 'handoff_initiated',
    'navigate-insights': 'handoff_initiated',
    'navigate-studies': 'handoff_initiated',
    'navigate-settings': 'handoff_initiated',
    'navigate-integrations': 'handoff_initiated',
    'navigate-micro-surveys': 'handoff_initiated',
    'navigate-pixel-events': 'handoff_initiated',
    'open-support': 'handoff_initiated',
    'open-booking': 'handoff_initiated',
    'choose-plan': 'handoff_initiated',
    reconnect: 'handoff_initiated',
    'retry-load': 'server_acknowledgement',
    'open-help': 'local_transition',
    'close-help': 'local_transition',
    'open-info': 'local_transition',
    'select-filter': 'local_transition',
    'select-sort': 'local_transition',
    'select-tab': 'local_transition',
    'clear-filter': 'local_transition',
    'select-page': 'local_transition',
    'open-admin-entity': 'handoff_initiated',
};
/** Action IDs with lifecycle validation retain their existing spelling, including retryCleanup. */
export const shopifyTrackingPages = {
    home: {
        pageId: 'home',
        route: '/',
        screens: ['default'],
        actions: {
            ...navigation,
            'create-test': 'local_transition',
            'open-test': 'local_transition',
            connect: 'handoff_initiated',
            resync: 'server_acknowledgement',
            'start-sync': 'server_acknowledgement',
            'save-preferences': 'local_transition',
            'open-guide': 'local_transition',
            'toggle-guide-step': 'local_transition',
            'open-capability': 'local_transition',
            'save-onboarding-details': 'server_acknowledgement',
        },
    },
    studies: {
        pageId: 'studies',
        route: '/tests',
        screens: ['default'],
        actions: {
            ...navigation,
            'load-tests': 'server_acknowledgement',
            'create-test': 'local_transition',
            'open-test': 'local_transition',
            'delete-setup': 'server_acknowledgement',
            'request-deletion': 'server_acknowledgement',
            'check-deletion': 'server_acknowledgement',
            'confirm-delete': 'local_transition',
            'cancel-delete': 'local_transition',
            'select-filter': 'local_transition',
            'select-page': 'local_transition',
        },
    },
    'study-builder': {
        pageId: 'study-builder',
        route: '/study-builder',
        screens: ['default', 'retired'],
        actions: {
            ...navigation,
            'choose-product': 'local_transition',
            'upload-image': 'server_acknowledgement',
            'open-guidance': 'local_transition',
            'evaluate-change': 'server_acknowledgement',
            'save-draft': 'server_acknowledgement',
            discard: 'local_transition',
            'delete-setup': 'server_acknowledgement',
            'request-deletion': 'server_acknowledgement',
            'check-deletion': 'server_acknowledgement',
            'run-study': 'server_acknowledgement',
            'open-suggestions': 'server_acknowledgement',
            'retry-suggestions': 'server_acknowledgement',
            'apply-suggestion': 'server_acknowledgement',
            'select-option': 'server_acknowledgement',
            'suggestion-feedback': 'server_acknowledgement',
            'open-results': 'handoff_initiated',
            'review-run': 'local_transition',
            'confirm-delete': 'local_transition',
            'cancel-delete': 'local_transition',
            'load-saved': 'local_transition',
            'keep-editing': 'local_transition',
            'toggle-options': 'local_transition',
            'select-field': 'local_transition',
        },
    },
    'study-run': {
        pageId: 'study-run',
        route: '/tests/run',
        screens: ['default', 'retired'],
        actions: {
            ...navigation,
            'run-study': 'server_acknowledgement',
            'open-results': 'handoff_initiated',
            'open-editor': 'handoff_initiated',
        },
    },
    'direct-study-results': {
        pageId: 'direct-study-results',
        route: '/tests/study-results',
        screens: ['default'],
        actions: {
            ...navigation,
            'create-next-test': 'server_acknowledgement',
            'delete-setup': 'server_acknowledgement',
            'request-deletion': 'server_acknowledgement',
            'check-deletion': 'server_acknowledgement',
            'confirm-delete': 'local_transition',
            'cancel-delete': 'local_transition',
            'select-tab': 'local_transition',
            'select-question': 'handoff_initiated',
            'select-treatment': 'local_transition',
            'open-editor': 'handoff_initiated',
        },
    },
    results: { pageId: 'results', route: '/tests/results', screens: ['retired'], actions: navigation },
    insights: {
        pageId: 'insights',
        route: '/insights',
        screens: ['default'],
        actions: {
            ...navigation,
            'test-setup': 'server_acknowledgement',
            'open-opportunity': 'local_transition',
            'close-opportunity': 'local_transition',
            'select-tab': 'local_transition',
            'select-filter': 'local_transition',
            'select-page': 'local_transition',
            'select-item': 'local_transition',
            'open-patterns': 'local_transition',
            'close-patterns': 'local_transition',
            'save-knowledge': 'server_acknowledgement',
            'dismiss-research': 'server_acknowledgement',
            'answer-knowledge': 'local_transition',
            'select-target': 'local_transition',
            'open-history': 'local_transition',
            'open-saved': 'local_transition',
            'start-answer': 'local_transition',
            'close-history': 'local_transition',
            'close-saved': 'local_transition',
            'back-answer': 'local_transition',
            'search-items': 'local_transition',
        },
    },
    settings: {
        pageId: 'settings',
        route: '/settings',
        screens: ['default'],
        actions: {
            ...navigation,
            connect: 'handoff_initiated',
            disconnect: 'server_acknowledgement',
            retryCleanup: 'server_acknowledgement',
            'confirm-disconnect': 'local_transition',
            'cancel-disconnect': 'local_transition',
        },
    },
    'settings-integrations': {
        pageId: 'settings-integrations',
        route: '/settings/integrations',
        screens: ['default'],
        actions: {
            ...navigation,
            'vote-provider': 'server_acknowledgement',
            'open-provider': 'local_transition',
            'close-provider': 'local_transition',
            'connect-provider': 'server_acknowledgement',
            'authorize-provider': 'handoff_initiated',
            'refresh-provider': 'server_acknowledgement',
            'load-resources': 'server_acknowledgement',
            'select-resource': 'server_acknowledgement',
            'select-property': 'local_transition',
            'select-project': 'local_transition',
            'link-property': 'server_acknowledgement',
            'unlink-source': 'server_acknowledgement',
            'confirm-unlink': 'local_transition',
            'cancel-unlink': 'local_transition',
            'open-provider-setup': 'handoff_initiated',
            'manage-integrations': 'handoff_initiated',
        },
    },
    support: {
        pageId: 'support',
        route: '/support',
        screens: ['default', 'retired'],
        actions: {
            ...navigation,
            'submit-ticket': 'server_acknowledgement',
            'new-ticket': 'local_transition',
        },
    },
    'micro-surveys': {
        pageId: 'micro-surveys',
        route: '/micro-surveys',
        screens: ['default', 'unavailable'],
        actions: {
            ...navigation,
            'create-survey': 'local_transition',
            'edit-survey': 'local_transition',
            'cancel-edit': 'local_transition',
            'save-survey': 'server_acknowledgement',
            'archive-survey': 'server_acknowledgement',
            'select-filter': 'local_transition',
            'add-choice': 'local_transition',
            'remove-choice': 'local_transition',
        },
    },
    'pixel-events': {
        pageId: 'pixel-events',
        route: '/pixel-events',
        screens: ['default', 'unavailable'],
        actions: {
            ...navigation,
            'select-filter': 'local_transition',
            'select-page': 'local_transition',
        },
    },
    'launch-admission': {
        pageId: 'launch-admission',
        route: '/',
        screens: ['default'],
        actions: {
            ...navigation,
            connect: 'handoff_initiated',
        },
    },
    'connection-recovery': {
        pageId: 'connection-recovery',
        route: '/',
        screens: ['default', 'failed', 'blocked'],
        actions: {
            ...navigation,
            connect: 'handoff_initiated',
        },
    },
};
export const shopifyUiPages = Object.values(shopifyTrackingPages);
//# sourceMappingURL=ui-shopify-pages.js.map